// extracted by mini-css-extract-plugin
module.exports = {"map":"map-module--map--c15v3"};